<template>
  <v-row>
    <v-col cols="3">
      <div class="d-flex flex-column align-stretch justify-start filtros">
        <div class="text-subtitle-1 font-weight-bold text-center mb-2">
          {{ fechaSeleccionadaInfo ? fechaSeleccionadaInfo.fechaCompleta : '' }}
        </div>

        <v-date-picker v-model="miniFecha" locale="es-mx" :first-day-of-week="1" no-title color="primary"
          :header-date-format="headerMiniCalendario" class="mb-3 mini-cal" @input="onSeleccionarDiaMini" full-width />

        <v-btn @click="abrirDialog()" color="primary">Calendarizar Paro</v-btn>
        <v-autocomplete v-model="miniCalParams.idArea" :items="areas" item-text="text" item-value="value"
          label="Área (Opcional)" dense hide-details class="mb-3" outlined clearable :loading="loadingAreas"  @change="filtrarEventosPorSemana"/>
        <v-autocomplete v-model="miniCalParams.idMaquinaIns" :items="maquinas" item-text="text" item-value="value"
          label="Máquina (Opcional)" dense hide-details class="mb-3" outlined clearable :loading="loadingMaquinas"  @change="filtrarEventosPorSemana"/>
        <v-autocomplete v-model="miniCalParams.idMolde"
          :items="moldes" item-text="text" item-value="value" label="Molde (Opcional)" dense hide-details
          class="mb-3" outlined clearable :loading="loadingMoldes" @change="filtrarEventosPorSemana"/>
        <v-autocomplete v-model="miniCalParams.idCausa" :items="causas" item-text="text" item-value="value"
          label="Causa (Opcional)" dense hide-details class="mb-3" outlined clearable :loading="loadingCausas"  @change="filtrarEventosPorSemana"/>
        <v-autocomplete v-model="miniCalParams.idSubCausa" :disabled="!miniCalParams.idCausa"
          :items="subCausasDisponibles" item-text="text" item-value="value" label="Sub Causa (Opcional)" dense
          hide-details class="mb-3" outlined clearable :loading="loadingSubcausas"  @change="filtrarEventosPorSemana"/>
      </div>
    </v-col>

    <v-col cols="9">
      <div class="calendar-header">
        <div v-for="(dia, i) in diasSemana" :key="i" class="day-header-cell">
          <div :class="['day-bubble', { today: dia.esHoy }]">
            {{ dia.numero }}
          </div>
          <div class="weekday-label">{{ dia.nombre }}</div>
        </div>
      </div>
      <v-progress-linear v-if="loadingCalendario" indeterminate color="yellow darken-2" />
      <div class="cal-scroll">
      <v-calendar v-model="value" type="week" :weekdays="weekday" :events="eventosFiltrados" hide-header color="primary"
        :event-color="getEventColor" :event-text-color="() => '#ffffff'" @click:event="abrirDesdeCalendario"
        @click:time="onClickTime">
        <template v-slot:event="{ event, timed }">
          <v-tooltip top open-delay="150" content-class="pp-tooltip" max-width="380" color="white" class="black--text">
            <template v-slot:activator="{ on, attrs }">
              <div class="my-event" :class="{ 'my-event--timed': timed }" v-bind="attrs" v-on="on">
                <div class="my-event__title">{{ event.title }}</div>
                <div v-if="event.subtitle" class="my-event__subtitle">{{ event.subtitle }}</div>
              </div>
            </template>

            <div class="tooltip-content">
              <div class="tooltip-row"><strong>Áreas:</strong> {{ areasLabel(event) }}</div>
              <div class="tooltip-row"><strong>Máquinas:</strong> {{ maquinasLabel(event) }}</div>
              <div v-if="event.descripcion" class="tooltip-row"><strong>Descripción:</strong> {{
                event.descripcion }}
              </div>
            </div>
          </v-tooltip>
        </template>
      </v-calendar>
      </div>
    </v-col>

    <v-dialog v-model="dialog" max-width="650px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-center text-subtitle-2 font-weight-bold">
          {{ modoEdicion ? 'Editar paro programado' : 'Crear paro programado' }}
        </v-card-title>
        <v-form ref="formParo" v-model="valido" lazy-validation @submit.prevent="onSubmit">
          <v-card-text>
            <div class="mb-0">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="form.motivo" label="Causa" :items="causas" item-text="text"
                    item-value="value" outlined dense :rules="[v => !!v || 'Obligatorio']" required clearable />
                </v-col>

                <v-col cols="6">
                  <v-autocomplete v-model="form.submotivo" label="Sub causa" :items="subCausasDisponibles2"
                    item-text="text" item-value="value" outlined dense clearable />
                </v-col>
              </v-row>
            </div>

            <!-- Áreas, Máquinas y Moldes -->
            <div class="mb-5">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="form.areas" :items="areas" multiple label="Áreas" chips outlined clearable
                    :return-object="false" item-text="text" item-value="value"
                    :rules="[v => (Array.isArray(v) && v.length > 0) || 'Selecciona al menos una área']" required />
                </v-col>

                <v-col cols="6">
                  <v-autocomplete v-model="form.maquinas" :items="maquinas" multiple label="Máquinas" chips outlined
                    clearable :return-object="false" item-text="text" item-value="value"
                    :rules="[v => (Array.isArray(v) && v.length > 0) || 'Selecciona al menos una máquina']" required />
                </v-col>

                <v-col cols="6">
                  <v-autocomplete v-model="form.moldes" :items="moldes" multiple label="Moldes (opcionales)" chips
                    outlined clearable :return-object="false" :item-text="labelMolde" item-value="value" />
                </v-col>
              </v-row>
            </div>

            <!-- Rango de inicio -->
            <div>
              <v-row>
                <v-col cols="6">
                  <v-menu v-model="menuDesde" :close-on-content-click="false" offset-y max-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.desde" label="Desde" readonly dense outlined v-bind="attrs" v-on="on"
                        :rules="rulesFechaDesde" required />
                    </template>
                    <v-date-picker v-model="form.desde" :min="startOfYear" :max="form.hasta || endOfYear" locale="es"
                      color="primary" dark header-color="primary" reactive show-current @input="menuDesde = false" />
                  </v-menu>
                </v-col>

                <v-col cols="6">
                  <v-menu v-model="menuInicio" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.horaInicio" label="Hora Inicio" readonly v-bind="attrs" v-on="on"
                        outlined dense :rules="rulesHoraInicio" required />
                    </template>
                    <v-time-picker v-model="form.horaInicio" format="24hr" />
                  </v-menu>
                </v-col>
              </v-row>
            </div>

            <!-- Rango de fin -->
            <div>
              <v-row>
                <v-col cols="6">
                  <v-menu v-model="menuHasta" :close-on-content-click="false" offset-y max-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.hasta" label="Hasta" readonly dense outlined v-bind="attrs" v-on="on"
                        :rules="rulesFechaHasta" required />
                    </template>
                    <v-date-picker v-model="form.hasta" :min="form.desde || startOfYear" :max="endOfYear" locale="es"
                      color="primary" header-color="primary" dark reactive show-current @input="menuHasta = false" />
                  </v-menu>
                </v-col>

                <v-col cols="6">
                  <v-menu v-model="menuFin" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.horaFin" label="Hora Fin" readonly v-bind="attrs" v-on="on" outlined
                        dense :rules="rulesHoraFin" required />
                    </template>
                    <v-time-picker v-model="form.horaFin" format="24hr" />
                  </v-menu>
                </v-col>
              </v-row>
            </div>

            <!-- Días que aplica (requerido solo si hay más de 2) -->
            <div v-if="diasSemanaEnRango.length > 2">
              <span class="text-subtitle-1 font-weight-bold text-center">Días que aplica</span>
              <v-row class="my-2 mt-n3">
                <v-col v-for="dia in diasSemanaEnRango" :key="dia.value" cols="12" sm="6" md="4" lg="3" class="py-0">
                  <v-checkbox v-model="form.dias" :label="dia.label" :value="dia.value" dense hide-details />
                </v-col>
              </v-row>
            </div>

            <!-- Alerta si cruza a día siguiente -->
            <v-alert v-if="esFinAntesQueInicio" color="orange lighten-4" dense elevation="0">
              <div class="d-flex justify-center align-center">
                <v-icon large class="mr-1" color="orange darken-1">mdi-alert-outline</v-icon>
                <span class="text-subtitle-1 font-weight-medium text-center">
                  La hora de fin es anterior a la de inicio; el paro continuará al día siguiente.
                </span>
              </div>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-btn v-if="modoEdicion" color="error" @click="abrirEliminar">Eliminar</v-btn>
            <v-spacer />
            <v-btn text color="success" @click="cerrarDialog" :loading="loadingGuardar">Cancelar</v-btn>
            <v-btn text color="error" :loading="loadingGuardar" type="submit">
              {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      miniFecha: null,

      listaDias: [
        'Domingo', 'Lunes', 'Martes', 'Miércoles',
        'Jueves', 'Viernes', 'Sábado'
      ],
      listaMeses: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      weekday: [1,2,3,4,5,6,0],
      value: null,

      eventosFiltrados: [],
      areas: [],
      maquinas: [],
      moldes: [],
      causas: [],
      subCausas: [],

      miniCalParams: {
        idArea: null,
        idMaquinaIns: null,
        idMolde: null,
        idCausa: null,
        idSubCausa: null,
      },

      valido: false,
      editandoId: null,
      modoEdicion: false,

      dialog: false,

      form: {
        motivo: null,
        submotivo: null,
        areas: null,
        maquinas: null,
        moldes: null,
        desde: null,
        horaInicio: null,
        dias: null,
      },
      formDefault: {
        motivo: null,
        submotivo: null,
        areas: null,
        maquinas: null,
        moldes: null,
        desde: null,
        horaInicio: null,
        dias: null,
      },

      menuInicio: false,
      menuFin: false,
      menuDesde: false,
      menuHasta: false,
      menuDesde1: false,
      menuHasta1: false,

      loadingCalendario: false,
      loadingAreas: false,
      loadingMaquinas: false,
      loadingMoldes: false,
      loadingCausas: false,
      loadingSubcausas: false,
      loadingGuardar: false,

      ignoreClickTimeUntil: 0,
    }
  },
  methods: {
    labelMolde: maquina => `${maquina.text} [${maquina.maquina}]`,
    initialize() {
      const hoy = new Date()
      const ymd = this.toLocalYMD(hoy)
      this.miniFecha = ymd
      this.value = ymd
      this.miniFecha = this.toLocalYMD(hoy)
      this.getAreas();
      this.getMaquinas();
      this.getMoldes();
      this.getCausas();
      this.getSubcausas();
    },

    getAreas() {
      this.loadingAreas = true;
      axios.get('/Areas')
        .then(({ data }) => {
          this.areas = (data || []).map(a => ({
            text: a.Nombre ?? a.nombre ?? String(a.text ?? a.Nombre ?? a.nombre),
            value: Number(a.IdArea ?? a.idArea ?? a.value)
          }));
        })
        .catch(console.error)
        .finally(() => { this.loadingAreas = false; });
    },
    getMaquinas() {
      this.loadingMaquinas = true;
      axios.get('/MaquinaInstancias')
        .then(({ data }) => {
          this.maquinas = (data || []).map(m => ({
            text: m.Nombre ?? m.nombre ?? String(m.text ?? m.Nombre ?? m.nombre),
            value: Number(m.IdMaquinaIns ?? m.idMaquinaIns ?? m.value),
            idMaquina: m.idMaquina,
          }));
        })
        .catch(console.error)
        .finally(() => { this.loadingMaquinas = false; });
    },
    getMoldes() {
      this.loadingMoldes = true;
      axios.get('/Moldes')
        .then(({ data }) => {
          this.moldes = (data || []).map(m => ({
            text: m.codigo ?? m.codigo ?? String(m.text ?? m.codigo ?? m.codigo),
            value: Number(m.idMolde ?? m.idMolde ?? m.value),
            idMaquina: m.idMaquina,
            maquina: m.maquina,
          }));
        })
        .catch(console.error)
        .finally(() => { this.loadingMoldes = false; });
    },
    getCausas() {
      this.loadingCausas = true;
      axios.get('/ParoTipos')
        .then(({ data }) => {
          const res = data.filter(item => item.oeeFactor === "DISPONIBILIDAD" && item.paroProgramado)
          this.causas = (res || []).map(c => ({
            text: c.nombre,
            value: Number(c.idParoTipo)
          }));
        })
        .catch(console.error)
        .finally(() => { this.loadingCausas = false; });
    },
    getSubcausas() {
      this.loadingSubcausas = true;
      axios.get('/SubParoTipos')
        .then(({ data }) => {
          this.subCausas = (data || []).map(sc => ({
            text: sc.nombreSubParoTipo,
            value: Number(sc.idSubParoTipo),
            idParoTipo: sc.idParoTipo
          }));
        })
        .catch(console.error)
        .finally(() => { this.loadingSubcausas = false; });
    },

    // Golpes a Back
    armarPayload() {
      const permitidos = new Set(
        (this.diasSemanaEnRango?.map(d => Number(d.value))) ?? [0,1,2,3,4,5,6]
      );

      const autoDias0a6 = (() => {
        const ds = new Date(`${this.form.desde}T00:00:00`);
        const hs = new Date(`${this.form.hasta}T00:00:00`);
        if (isNaN(ds) || isNaN(hs) || hs < ds) return [];
        const s = new Set();
        const d = new Date(ds);
        while (d <= hs) { s.add(d.getDay()); d.setDate(d.getDate() + 1); }
        return Array.from(s);
      })();

      const diasUI0a6 = Array.isArray(this.form.dias) ? this.form.dias.map(Number) : [];
      let dias0a6 = [...new Set([...autoDias0a6, ...diasUI0a6])]
        .filter(v => permitidos.has(v))
        .sort((a, b) => a - b);

      if (dias0a6.length === 0 && this.form?.desde) {
        dias0a6 = [new Date(`${this.form.desde}T00:00:00`).getDay()];
      }

      const dias1a7 = [...new Set(dias0a6.map(d => (d === 0 ? 7 : d)))].sort((a,b) => a - b);

      return {
        titulo: this.form.titulo?.trim() || null,
        descripcion: this.form.descripcion?.trim() || null,
        idParoTipo: this.form.motivo,
        idSubParoTipo: this.form.submotivo || null,
        areas: Array.isArray(this.form.areas) ? this.form.areas : [],
        maquinas: Array.isArray(this.form.maquinas) ? this.form.maquinas : [],
        moldes: Array.isArray(this.form.moldes) ? this.form.moldes : [],
        desde: this.form.desde,
        hasta: this.form.hasta,
        horaInicio: (this.form.horaInicio || '').slice(0,5),
        horaFin:   (this.form.horaFin   || '').slice(0,5),
        dias: dias1a7,
        reasignarIdProgramado: false,
        idParoProgramado: this.form.idParoProgramado ?? null,
        idProgramadoOrigen: this.form.idProgramado
      };
    },
    async filtrarEventosPorSemana() {
      this.loadingCalendario = true;
      this.eventosFiltrados = [];
      try {
        const { data } = await axios.get('/ParoProgramado/Listar', {
          params: {
            desde: this.fechaSeleccionadaInfo.fechaInicioSemana,
            hasta: this.fechaSeleccionadaInfo.fechaFinSemana,
            IdArea: this.miniCalParams.idArea,
            IdMaquina: this.miniCalParams.idMaquinaIns,
            IdParoTipo: this.miniCalParams.idCausa,
            IdSubParoTipo: this.miniCalParams.idSubCausa,
            IdMolde: this.miniCalParams.idMolde,
            incluirInactivos: false,
          }
        });

        const items = Array.isArray(data) ? data : [];
        const eventos = [];

        // Semana visible (lunes–domingo)
        const [wsY, wsM, wsD] = this.fechaSeleccionadaInfo.fechaInicioSemana.split('-').map(Number);
        const weekStart = new Date(wsY, wsM - 1, wsD, 0, 0, 0, 0);
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        items.forEach(it => {
          if (!it.desde || !it.hasta) return;

          // Rango real del paro (solo fecha)
          const fechaDesdeStr = it.desde.split('T')[0]; // YYYY-MM-DD
          const fechaHastaStr = it.hasta.split('T')[0];

          const [py1, pm1, pd1] = fechaDesdeStr.split('-').map(Number);
          const [py2, pm2, pd2] = fechaHastaStr.split('-').map(Number);

          const progIni = new Date(py1, pm1 - 1, pd1, 0, 0, 0, 0);
          const progFin = new Date(py2, pm2 - 1, pd2, 23, 59, 59, 999);

          // Si la semana ni siquiera se cruza con el rango del paro, lo saltamos
          if (weekEnd < progIni || weekStart > progFin) return;

          // dias: 1=Lunes ... 7=Domingo
          const diasRaw = Array.isArray(it.dias) ? it.dias : [];
          const diasBack = diasRaw
            .map(n => Number(n))
            .filter(n => !Number.isNaN(n) && n >= 1 && n <= 7);

          // Si no trae días, asumimos que aplica a todos
          const diasUsar = diasBack.length ? diasBack : [1, 2, 3, 4, 5, 6, 7];

          diasUsar.forEach(diaBack => {
            // díaBack 1..7 → offset respecto al lunes de la semana
            const offset = diaBack - 1; // 1->0 (Lunes), 2->1 (Martes), ..., 7->6 (Domingo)
            const d = new Date(weekStart);
            d.setDate(weekStart.getDate() + offset);

            // Ese día concreto debe caer dentro del rango del paro
            if (d < progIni || d > progFin) return;

            const hi = (it.horaInicio && it.horaInicio.length >= 4)
              ? it.horaInicio.slice(0, 5)
              : '00:00';
            const hf = (it.horaFin && it.horaFin.length >= 4)
              ? it.horaFin.slice(0, 5)
              : '23:59';

            const [hih, him] = hi.split(':').map(Number);
            const [hfh, hfm] = hf.split(':').map(Number);

            const startDate = new Date(
              d.getFullYear(),
              d.getMonth(),
              d.getDate(),
              hih,
              him,
              0,
              0
            );

            let endDate = new Date(
              d.getFullYear(),
              d.getMonth(),
              d.getDate(),
              hfh,
              hfm,
              0,
              0
            );

            // Si la hora fin es <= inicio, asumimos que cruza al día siguiente
            if ((hfh * 60 + hfm) <= (hih * 60 + him)) {
              endDate.setDate(endDate.getDate() + 1);
            }

            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const ymd = `${year}-${month}-${day}`;

            eventos.push({
              title: it.motivoNombre || 'Paro programado',
              subtitle: it.submotivoNombre || null,
              descripcion: it.descripcion || null,
              areas: it.areasDetalle || [],
              maquinas: it.maquinasDetalle || [],
              moldes: it.moldesDetalle || [],
              start: startDate,
              end: endDate,
              color: this.seededColor(`${it.idParoProgramado}-${ymd}`),
              timed: true,
              idParoProgramado: it.idParoProgramado,
              idParo: it.idParoProgramado,
              idParoTipo: it.idParoTipo ?? null,
              idSubParoTipo: it.idSubParoTipo ?? null,
              idProgramado: it.idProgramado ?? null,
              activo: it.activo ?? true
            });
          });
        });

        this.eventosFiltrados = eventos;
      } catch (err) {
        console.error(err);
        this.eventosFiltrados = [];
      } finally {
        this.loadingCalendario = false;
      }
    },
    async onSubmit() {
      const ok = this.$refs.formParo?.validate();
      if (!ok) return;
      const payload = this.armarPayload();
      this.loadingGuardar = true;
      try {
        if (this.modoEdicion && this.editandoId) {
          await this.actualizarParo(payload);
        } else {
          await this.crearParo(payload);
        }
        this.cerrarDialog();
        this.filtrarEventosPorSemana?.();
      } finally {
        this.loadingGuardar = false;
      }
    },
    actualizarParo(payload) {
      return axios.put(`/ParoProgramado/ActualizarMasivo`, payload);
    },
    crearParo(payload) {
      return axios.post('/ParoProgramado/Crear', payload);
    },

    // Acciones en dialogos
    abrirDialog() {
      this.ignoreClickTimeUntil = Date.now() + 250

      this.form = JSON.parse(JSON.stringify(this.formDefault));

      this.modoEdicion = false;

      this.$nextTick(() => this.$refs.formParo?.resetValidation());
      this.dialog = true;
      this.menuDesde = this.menuHasta = this.menuInicio = this.menuFin = false;
    },
    abrirDesdeCalendario(payload) {
      this.ignoreClickTimeUntil = Date.now() + 250

      const ev = payload?.event ?? payload;
      if (!ev) return;

      const sStart = ev.start || ev.inicio || ev.fechaInicio || null;
      const sEnd = ev.end || ev.fin || ev.fechaFin || null;
      const startDT = this.parseCalDT(sStart);
      const endDT = this.parseCalDT(sEnd);

      this.form = {
        titulo: ev.title || ev.titulo || ev.name || null,
        descripcion: ev.descripcion || ev.description || null,
        motivo: ev.idParoTipo ?? null,
        submotivo: ev.idSubParoTipo ?? null,
        areas: Array.isArray(ev.areas) ? ev.areas.map(a => a?.id ?? a) : [],
        maquinas: Array.isArray(ev.maquinas) ? ev.maquinas.map(m => m?.id ?? m) : [],
        moldes: Array.isArray(ev.moldes) ? ev.moldes.map(m => m?.id ?? m) : [],
        desde: this.extractYMD(sStart) || this.toYMD(startDT),
        hasta: this.extractYMD(sEnd) || this.toYMD(endDT),
        horaInicio: this.extractHM(sStart) || this.toHM(startDT),
        horaFin: this.extractHM(sEnd) || this.toHM(endDT),
        dias: [],
        idProgramado: ev.idProgramado,
        idParoProgramado: ev.idParoProgramado,
      };

      this.modoEdicion = true;
      this.editandoId = ev.idParo ?? ev.id ?? null;

      this.$nextTick(() => this.$refs.formParo?.resetValidation());
      this.dialog = true;
      this.menuDesde = this.menuHasta = this.menuInicio = this.menuFin = false;
    },
    cerrarDialog() {
      this.menuDesde = false;
      this.menuDesde1 = false;
      this.menuHasta = false;
      this.menuHasta1 = false;
      this.menuInicio = false;
      this.menuFin = false;

      if (this.$refs.formParo) {
        this.$refs.formParo.resetValidation();
      }

      this.form = {
        titulo: null,
        descripcion: null,
        motivo: null,
        submotivo: null,
        areas: [],
        maquinas: [],
        desde: null,
        hasta: null,
        dias: [],
        horaInicio: null,
        horaFin: null
      };

      this.valido = false;

      this.dialog = false;
      this.modoEdicion = false;
      this.editandoId = null;
    },
    onClickTime(payload) {
      if (Date.now() < this.ignoreClickTimeUntil) return
      this.dialog = true

      const { date, time } = payload || {}

      // Parse base date (local)
      const [Y, M, D] = String(date).split('-').map(Number)

      // time viene "HH:mm"
      const [h, m] = String(time || '00:00').split(':').map(Number)
      const total = (h * 60) + m

      // Redondeo a la media hora más cercana
      let rounded = Math.round(total / 30) * 30

      // Si redondea a 24:00 -> 00:00 del siguiente día
      let startDayOffset = 0
      if (rounded >= 24 * 60) {
        rounded = 0
        startDayOffset = 1
      }

      const inicioDate = new Date(Y, (M - 1), D + startDayOffset, 0, 0, 0, 0)
      const hh = String(Math.floor(rounded / 60)).padStart(2, '0')
      const mm = String(rounded % 60).padStart(2, '0')
      const horaInicio = `${hh}:${mm}`

      // Fin = inicio + 60 min
      const finTotal = rounded + 60
      const endDayOffset = finTotal >= 24 * 60 ? 1 : 0
      const finMins = finTotal % (24 * 60)

      const hhFin = String(Math.floor(finMins / 60)).padStart(2, '0')
      const mmFin = String(finMins % 60).padStart(2, '0')
      const horaFin = `${hhFin}:${mmFin}`

      const finDate = new Date(
        inicioDate.getFullYear(),
        inicioDate.getMonth(),
        inicioDate.getDate() + endDayOffset,
        0, 0, 0, 0
      )

      const toYMD = (d) => {
        const y = d.getFullYear()
        const mo = String(d.getMonth() + 1).padStart(2, '0')
        const da = String(d.getDate()).padStart(2, '0')
        return `${y}-${mo}-${da}`
      }

      this.form.desde = toYMD(inicioDate)
      this.form.horaInicio = horaInicio
      this.form.hasta = toYMD(finDate)
      this.form.horaFin = horaFin
    },

    // Helpers para calendario
    areasLabel(evt) {
      const arr = evt.areas || [];
      const names = arr.map(a => a.nombre || a.name || a.text || a).filter(Boolean);
      return names.length ? names.join(', ') : '—';
    },
    maquinasLabel(evt) {
      const arr = evt.maquinas || [];
      const names = arr.map(m => m.nombre || m.name || m.text || m).filter(Boolean);
      return names.length ? names.join(', ') : '—';
    },
    seededColor(key) {
      const s = String(key ?? Math.random());
      let h = 2166136261;
      for (let i = 0; i < s.length; i++) h = (h ^ s.charCodeAt(i)) * 16777619 >>> 0;

      const hue = h % 360;
      const sat = 70;  // %
      const lig = 42;  // %
      return `hsl(${hue}, ${sat}%, ${lig}%)`;
    },

    // Helpers para abrir evento
    parseCalDT(s) {
      if (!s) return null;
      if (s instanceof Date) return new Date(s);
      const [d, t = '00:00'] = String(s).split(/[ T]/);
      const [Y, M, D] = d.split('-').map(Number);
      const [h, m] = t.split(':').map(Number);
      const dt = new Date(Y, (M || 1) - 1, D || 1, h || 0, m || 0);
      return isNaN(dt.getTime()) ? null : dt;
    },
    extractYMD(s) { 
      const m = String(s || '').match(/^(\d{4}-\d{2}-\d{2})/); return m ? m[1] : null; 
    },
    extractHM(s) { 
      const m = String(s || '').match(/[ T](\d{2}):(\d{2})/); return m ? `${m[1]}:${m[2]}` : null; 
    },
    toYMD(d) { 
      if (!d) return null; const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0'); return `${y}-${m}-${day}`; 
    },
    toHM(d) { 
      if (!d) return null; const h = String(d.getHours()).padStart(2, '0'), m = String(d.getMinutes()).padStart(2, '0'); return `${h}:${m}`; 
    },
    toLocalYMD(d) {
      const x = new Date(d);
      const y = x.getFullYear();
      const m = String(x.getMonth() + 1).padStart(2, '0');
      const day = String(x.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
  },
  computed: {
    fechaSeleccionadaInfo() {
      const str = this.miniFecha || this.value
      if (!str) return null

      const [anio, mes, dia] = str.split('-').map(n => parseInt(n, 10))
      const d = new Date(anio, mes - 1, dia)

      const diaNumero = d.getDate()
      const diaNombre = this.listaDias[d.getDay()]
      const mesNumero = d.getMonth() + 1
      const mesNombre = this.listaMeses[d.getMonth()]

      const target = new Date(Date.UTC(anio, mes - 1, dia))
      const dayNr = (target.getUTCDay() + 6) % 7
      target.setUTCDate(target.getUTCDate() - dayNr + 3)
      const firstThu = new Date(Date.UTC(target.getUTCFullYear(), 0, 4))
      const semana = 1 + Math.round((target - firstThu) / 604800000)

      const inicioSemana = new Date(d)
      const dow = d.getDay()
      const diffToMonday = (dow + 6) % 7
      inicioSemana.setDate(d.getDate() - diffToMonday)

      const finSemana = new Date(inicioSemana)
      finSemana.setDate(inicioSemana.getDate() + 6)

      const toISO = (dt) => {
        const y = dt.getFullYear()
        const m = String(dt.getMonth() + 1).padStart(2, '0')
        const dd = String(dt.getDate()).padStart(2, '0')
        return `${y}-${m}-${dd}`
      }

      return {
        semana,
        diaNumero,
        diaNombre,
        mesNumero,
        mesNombre,
        anio,
        fechaISO: str,
        fechaCompleta: `${diaNombre} ${diaNumero} de ${mesNombre} de ${anio}`,
        fechaInicioSemana: toISO(inicioSemana),
        fechaFinSemana: toISO(finSemana)
      }
    },

    headerMiniCalendario() {
      return (isoDate) => {
        const baseStr = isoDate || this.miniFecha || this.value
        if (!baseStr) return ''

        const [anio, mes] = baseStr.split('-').map(n => parseInt(n, 10))
        const mesNombre = this.listaMeses[mes - 1]

        return `${mesNombre} ${anio}`
      }
    },
    diasSemana() {
      const baseStr =
        this.miniFecha ||
        this.value ||
        this.toLocalYMD(new Date())

      const [Y, M, D] = String(baseStr).split('-').map(Number)
      const base = new Date(Y, (M || 1) - 1, D || 1, 0, 0, 0, 0)

      const day = base.getDay()
      const diffToMonday = (day + 6) % 7
      const monday = new Date(base)
      monday.setDate(base.getDate() - diffToMonday)

      const etiquetas = ['L', 'M', 'M', 'J', 'V', 'S', 'D']
      const hoyISO = this.toLocalYMD(new Date())

      const resultado = []

      for (let i = 0; i < 7; i++) {
        const d = new Date(monday)
        d.setDate(monday.getDate() + i)

        const iso = this.toLocalYMD(d)

        resultado.push({
          numero: d.getDate(),
          nombre: etiquetas[i],
          fechaISO: iso,
          esHoy: iso === hoyISO
        })
      }

      return resultado
    },

    moldesDisponibles() {
      let res = this.moldes.filter(item => item.idMaquina == this.miniCalParams.idMaquinaIns)
      return res;
    },
    moldesDisponibles2() {
      const maquinas = Array.isArray(this.form.maquinas) ? this.form.maquinas : []

      const idsMaquinas = maquinas
        .map(x => x?.id ?? x?.IdMaquina ?? x)
        .filter(v => v !== null && v !== undefined)

      if (!idsMaquinas.length) return []

      return (this.moldes || []).filter(m =>
        idsMaquinas.includes(m?.idMaquina ?? m?.IdMaquina)
      )
    },
    subCausasDisponibles() {
      let res = this.subCausas.filter(item => item.idParoTipo == this.miniCalParams.idCausa)
      return res;
    },
    subCausasDisponibles2() {
      let res = this.subCausas.filter(item => item.idParoTipo == this.form.motivo)
      return res;
    },

    diasSemanaEnRango() {
      const { desde, hasta } = this.form
      if (!desde || !hasta) return []

      const parseYMD = (str) => {
        const [y, m, d] = str.split('-').map(Number)
        return new Date(y, m - 1, d)
      }

      const set = new Set()
      let cur = parseYMD(desde)
      const fin = parseYMD(hasta)

      while (cur <= fin) {
        const jsDay = cur.getDay()
        const value = jsDay === 0 ? 7 : jsDay
        set.add(value)
        cur.setDate(cur.getDate() + 1)
      }

      return Array.from(set)
        .sort((a, b) => a - b)
        .map(value => ({
          value,
          label: this.listaDias[value === 7 ? 0 : value]
        }))
    },
    esFinAntesQueInicio() {
      if (!this.form.horaInicio || !this.form.horaFin) return false;
      return this.form.horaFin < this.form.horaInicio; // compara "HH:mm"
    },
    rulesFechaDesde() {
      return [
        v => !!v || 'Obligatorio',
        v =>
          !this.form.hasta ||
          v <= this.form.hasta ||
          'No puede ser mayor que "Hasta"',
      ]
    },
    rulesFechaHasta() {
      return [
        v => !!v || 'Obligatorio',
        v =>
          !this.form.desde ||
          v >= this.form.desde ||
          'No puede ser menor que "Desde"',
      ]
    },
    rulesHoraInicio() {
      return [
        v => !!v || 'Obligatoria',
      ]
    },
    rulesHoraFin() {
      return [
        v => !!v || 'Obligatoria',
        v => {
          if (!v || !this.form.horaInicio) return true

          // Si las fechas son distintas, permitimos cualquier hora
          if (this.form.desde && this.form.hasta && this.form.desde !== this.form.hasta) {
            return true
          }

          // Mismo día: Hora Fin debe ser estrictamente mayor
          return (
            v > this.form.horaInicio ||
            'Debe ser mayor que la Hora Inicio'
          )
        }
      ]
    },
  },
  watch: {
    // 'miniCalParams.idMaquinaIns'(nv) {
    //   this.miniCalParams.idMolde = null;
    // },
    'miniCalParams.idCausa'(nv) {
      this.miniCalParams.idSubCausa = null;
    },
    'form.motivo'(nv) {
      this.form.submotivo = null;
    },
    // 'form.maquinas'(nv) {
    //   if (!Array.isArray(nv) || !nv.length) {
    //     this.form.moldes = []
    //     return
    //   }

    //   if (!Array.isArray(this.moldes) || !this.moldes.length) return

    //   const disponiblesIds = (this.moldesDisponibles2 || [])
    //     .map(m => Number(m?.value))
    //     .filter(v => Number.isFinite(v))

    //   if (!disponiblesIds.length) return

    //   const actuales = Array.isArray(this.form.moldes) ? this.form.moldes : []
    //   this.form.moldes = actuales
    //     .map(x => Number(x))
    //     .filter(id => Number.isFinite(id) && disponiblesIds.includes(id))
    // },
    'miniFecha'(nv) {
      if (nv && nv !== this.value) this.value = nv
      this.filtrarEventosPorSemana();
    },
    value (nv) {
      if (nv && nv !== this.miniFecha) this.miniFecha = nv
    }
  },
  mounted() {
    this.initialize();
  }
}
</script>

<!-- Para mini calendario en lateral izquiero -->
<style scoped>
/* Tabla: 7 columnas iguales */
.mini-cal ::v-deep .v-date-picker-table table {
  width: 100%;
  table-layout: fixed;
}

/* Celdas centradas, sin padding extra */
.mini-cal ::v-deep .v-date-picker-table th,
.mini-cal ::v-deep .v-date-picker-table td {
  text-align: center;
  padding: 0;
}

/* Botón del día: sin fondo, sin borde, sin sombra */
.mini-cal ::v-deep .v-date-picker-table .v-btn,
.mini-cal ::v-deep .v-date-picker-table .v-btn.v-btn--text,
.mini-cal ::v-deep .v-date-picker-table .v-btn.v-btn--rounded {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

/* Quitar overlay (ripple/fondo) */
.mini-cal ::v-deep .v-date-picker-table .v-btn::before {
  background-color: transparent !important;
}

/* Números por defecto: negros y centrados */
.mini-cal ::v-deep .v-date-picker-table .v-btn__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000 !important;
}

/* Día seleccionado: bolita azul con número blanco */
.mini-cal ::v-deep .v-date-picker-table .v-btn.v-btn--active {
  width: 32px;
  height: 32px;
  min-width: 32px;
  margin: 0 auto;
  border-radius: 50% !important;
  background-color: #1976d2 !important;
}

.mini-cal ::v-deep .v-date-picker-table .v-btn.v-btn--active .v-btn__content {
  color: #fff !important;
}
</style>
<style scoped>
/* ------------------------------------------------ */
/* 1) Oculta completamente la cabecera nativa week   */
/* ------------------------------------------------ */
.v-calendar-weekly__head {
  display: none !important;
}

/* ------------------------------------------------ */
/* 2) Header personalizado: flex + padding-left       */
/* ------------------------------------------------ */
.calendar-header {
  display: flex;
  align-items: center;
  /* Ajusta este valor al ancho de la columna de horas */
  padding-left: 60px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Cada “celda” de día */
.day-header-cell {
  flex: 1;
  text-align: center;
}

/* ------------------------------------------------ */
/* 3) Burbuja de número de día                       */
/* ------------------------------------------------ */
.day-bubble {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #e0e0e0;
  color: #282828;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 17px;
}

/* La burbuja del día actual en azul */
.day-bubble.today {
  background: #1976d2;
  color: #fff;
}

/* Nombre abreviado de cada día */
.weekday-label {
  font-size: 15px;
  color: #777;
  margin-top: 4px;
}

.my-event {
  color: #fff;
  border-radius: 10px;
  padding: 6px 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);

  /* Nuevo layout */
  display: grid;
  grid-template-rows: auto 1fr;
  /* título arriba, submotivo ocupa el resto */
  gap: 4px;
  height: 100%;
  overflow: hidden;
  line-height: 1.2;
}

/* Título: centrado, 2 líneas máx, que QUEPA (wrap) */
.my-event__title {
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  white-space: normal;
  /* <- quita el nowrap */
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  /*-webkit-line-clamp: 2;        /* máx 2 líneas */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Submotivo: hasta 4 líneas, rellena el bloque */
.my-event__subtitle {
  font-size: 11px;
  opacity: .95;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  /*-webkit-line-clamp: 4;        /* máx 4 líneas (ajústalo si tu bloque es más alto) */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Tooltip, igual */
.tooltip-content {
  max-width: 360px;
  padding: 6px 8px;
}

.tooltip-row {
  margin: 2px 0;
  font-size: 12px;
}

.cal-col { min-width: 0; min-height: 0; } /* importante en layouts flex */

.cal-panel{
  display: flex;
  flex-direction: column;
  height: calc(100vh - 260px);  /* ajusta este offset a tu header/tabs */
  min-height: 0;
}

.cal-scroll{
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;            /* aquí queda el scroll */
  overflow-x: hidden;
}

</style>